import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  ViewEncapsulation,
  input,
} from '@angular/core';

@Component({
  selector: 'accredible-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class AccredibleIconComponent {
  icon = input('');
  size = input<string>(null); // size in px
  supportRtl = input(false);
  ariaHidden = input(true);

  @HostBinding('class')
  get classes(): string {
    return this.supportRtl() ? 'support-rtl' : '';
  }
}
